import { ActivityType, ACTIVITY_CONFIGS } from '../../types/activityConfig';
import { Dog, User } from '../../types';

const ALL_ACTIVITIES = Object.keys(ACTIVITY_CONFIGS) as ActivityType[];

export interface ActivityTrainerOption {
  value: string;
  label: string;
}

export function getDogActivityTrainerOptions(
  dog: Dog | undefined,
  activity: ActivityType,
): ActivityTrainerOption[] {
  if (!dog) return [];

  const options = new Map<string, ActivityTrainerOption>();
  for (const assignment of dog.trainers || []) {
    if (!assignment?.trainerId || !assignment.activities?.includes(activity)) continue;
    const trainer = assignment.trainerId;
    if (typeof trainer === 'string' || !trainer._id ||
        (trainer.role && !trainer.role.includes('trainer')) ||
        (trainer.activities && !trainer.activities.includes(activity))) continue;
    options.set(trainer._id, { value: trainer._id, label: trainer.username });
  }

  for (const structure of dog.structureIds || []) {
    if (!structure || typeof structure === 'string') continue;
    const structureActivities = structure.activities?.length ? structure.activities : ALL_ACTIVITIES;
    if (!structureActivities.includes(activity)) continue;

    for (const member of structure.trainerIds || []) {
      if (!member || typeof member === 'string') continue;
      const trainer = member as User;
      if (!trainer._id || !trainer.role?.includes('trainer')) continue;
      const allowedActivities = trainer.activities ?? ALL_ACTIVITIES;
      if (!allowedActivities.includes(activity)) continue;
      options.set(trainer._id, { value: trainer._id, label: trainer.username });
    }
  }

  return Array.from(options.values());
}
